export default ['$stateProvider', $stateProvider => {
    $stateProvider
      .state('guestpage', {
        url: '/guests',
        component: 'guestPage'
      })
      ;
  }];
  


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/guest.routes.js